// Load data from a script tag created with django's json_script filter
export function load_json_script(id) {
    return JSON.parse(document.getElementById(id).textContent)
}
